// import config from "@/core/net/config";

import config from '../js/config';

export default {
    autoTfn () {
        (function (para) {
            
            var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script', x = null, y = null;
            if (typeof (w['sensorsDataAnalytic201505']) !== 'undefined') {
                return false;
            }
            w['sensorsDataAnalytic201505'] = n;
            w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
            var ifs = ['track','quick','register','registerPage','registerOnce','trackSignup', 'trackAbtest', 'setProfile','setOnceProfile','appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify','login','logout','trackLink','clearAllRegister','getAppStatus','setItem','deleteItem'];
            for (var i = 0; i < ifs.length; i++) {
                w[n][ifs[i]] = w[n].call(null, ifs[i]);
            }
            if (!w[n]._t) {
                x = d.createElement(s), y = d.getElementsByTagName(s)[0];
                x.async = 1;
                x.src = p;
                x.setAttribute('charset','UTF-8');
                w[n].para = para;
                y.parentNode.insertBefore(x, y);
            }
        })({
            sdk_url: 'https://uniondrug-web-static.uniondrug.cn/sensorsdata1.22.6.min.js',
            use_client_time:true,
            name: 'sensors',
            server_url: config.config().sensor_track_server, 
            is_track_single_page:true,
            show_log:true,
        });
        sensors.quick("autoTrack");
    }
}
